import { useUser } from "@clerk/nextjs";
import ItineraryItem from "components/guide/itinerary/ItineraryItem";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useInView } from "react-cool-inview";
import { BiCalendarStar } from "react-icons/bi";
import { viatorFreetextSearchClient } from "utils/helpers/viator";
import guideStyles from "../Guide.module.scss";
import RegenButton from "../components/RegenButton";
import SectionTitle from "../section/SectionTitle";
import styles from "./Itinerary.module.scss";
export default function Itinerary({
  items = [],
  location,
  setItineraryItems,
  slug,
}) {
  let usedActivityTitles = [];
  const [viatorActivities, setViatorActivities] = useState([]);

  const router = useRouter();

  const { isLoaded, user } = useUser();

  const { inView, observe } = useInView({
    unobserveOnEnter: true,
  });

  useEffect(() => {
    if (!inView || !location) return;

    (async () => {
      const viatorData = await viatorFreetextSearchClient({
        searchTerm: `${location?.city}, ${location?.country}`,
        count: items?.length,
        withGeocodeInfo: true,
        withDestinationInfo: true,
        location: {
          city: location?.city,
          country_code: location?.country_code,
        },
      });

      let existingProductCodes = {};

      const uniqueNewProducts = viatorData?.products?.filter((product) => {
        const isUnique = !existingProductCodes[product?.productCode];

        existingProductCodes[product?.productCode] = true;

        const doesNotContainBannedKeywords = ![
          "transfer",
          "airport",
          "taxi",
          "shuttle",
          "pick-up",
          "pick up",
        ].some((word) => product?.title?.toLowerCase().includes(word));

        return isUnique && doesNotContainBannedKeywords;
      });

      setViatorActivities(uniqueNewProducts);
      setItineraryItems((prevItems) => {
        return prevItems.map((item, index) => {
          return {
            ...item,
            viatorActivity: uniqueNewProducts?.[index] ?? null,
          };
        });
      });
    })();
  }, [inView]);

  const itineraryItems = items.map((item, index) => {
    const uniqueActivities = item?.activities?.filter((activity) => {
      return !usedActivityTitles?.includes(activity?.title);
    });

    const uniqueActivityTitles = uniqueActivities.map(
      (activity) => activity?.title
    );

    usedActivityTitles = [...usedActivityTitles, ...uniqueActivityTitles];

    const processedItem = {
      ...item,
      activities: uniqueActivities,
      viatorActivity: viatorActivities?.[index] ?? null,
    };

    return (
      <ItineraryItem
        key={`itinerary-item-${index}-${item?.id}`}
        item={processedItem}
        layout="text"
        location={location}
        setItineraryItems={setItineraryItems}
      />
    );
  });

  if (!items) {
    return null;
  }

  const isAdminUser =
    user?.primaryEmailAddress?.emailAddress?.includes("andrewbraundev") ||
    user?.primaryEmailAddress?.emailAddress?.includes("rob@wherenext.to");

  return (
    <section className={`${styles.container}`} id="itinerary" ref={observe}>
      <div className={`${guideStyles.section}`}>
        {isAdminUser && <RegenButton section="itinerary" slug={slug} />}
        <SectionTitle title="Itinerary" icon={<BiCalendarStar />} />
        <div className={`${styles.items}`}>{itineraryItems}</div>
      </div>
    </section>
  );
}
